'use client'

import { ProjectDisplayFragment } from '@/gql/generated/graphql'
import { InfoIcon, BodyText, RefreshIcon } from 'design-configuration/components'
import { Button } from '@components/button'
import * as React from 'react'
import { getInvocationFromTokenId, SoloViewerToken } from '@utils/common'
import { isOob } from '.'
import SwitchToggle from '@components/switch-toggle'
import { generatedSampleId } from './solo-display'

type SoloViewFooterProps = {
  token: SoloViewerToken
  project: ProjectDisplayFragment
  showLiveView: boolean
  toggleLiveView: () => void
  toggleDisplayNotes: () => void
  onGenerate: () => void
}

export const SoloViewFooter = ({
  token,
  project,
  showLiveView,
  toggleLiveView,
  toggleDisplayNotes,
  onGenerate
}: SoloViewFooterProps): React.ReactElement | null => {
  const generatedSample = token.id === generatedSampleId
  return (
    <div className="gap-y-sm flex w-full flex-col items-center justify-between md:flex-row">
      <div className="gap-x-sm flex">
        <BodyText className="text-on-surface-inverted">
          {`${project.name} ${isOob(token) ? 'sample' : `#${getInvocationFromTokenId(token.token_id)}`}`}
        </BodyText>
        <div className="hidden md:block">
          <Button
            onClick={(event) => {
              event.stopPropagation()
              toggleDisplayNotes()
            }}
            colorTheme="inverted-icon"
            size="small"
          >
            <InfoIcon className="w-sm h-sm" />
          </Button>
        </div>
      </div>
      <div className="gap-x-sm flex">
        <SwitchToggle
          leftLabel="Live view"
          variant="light"
          switchedRight={showLiveView || generatedSample}
          onSwitchChange={() => {
            if (generatedSample) return
            toggleLiveView()
          }}
          disabled={generatedSample}
          altLabelLeftText={generatedSample ? 'Live view is required for generated samples' : ''}
          className="w-auto flex-shrink-0 justify-start sm:justify-end"
        />
        <Button
          onClick={(event) => {
            event.stopPropagation()
            toggleDisplayNotes()
          }}
          colorTheme="inverted-icon"
          className="md:hidden"
        >
          <InfoIcon className="w-sm h-sm" />
        </Button>
        {project.max_invocations > (project.invocations ?? 0) && (
          <>
            <div className="hidden md:flex">
              <Button
                onClick={(event) => {
                  event.stopPropagation()
                  onGenerate()
                }}
                colorTheme={'inverted-secondary'}
                iconLeft={<RefreshIcon className="w-sm h-sm fill-on-surface-inverted" />}
              >
                Generate new sample
              </Button>
            </div>
            <div className="flex md:hidden">
              <Button
                onClick={(event) => {
                  event.stopPropagation()
                  onGenerate()
                }}
                colorTheme={'inverted-icon'}
              >
                <RefreshIcon className="w-sm h-sm fill-on-surface-inverted" />
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
